import * as React from "react"
import * as _ from "lodash";
import { connect } from "react-redux"
import { IAppState } from "../models/IAppState";
import ConverseChat from "@curefit/converse-chat-sdk";
import { CONVERSE_SDK_EVENTS, eventDispatcher } from "@curefit/converse-chat-sdk";
import { NewTwilioComponentProps } from "./NewTwilioComponent";
import { TwilioActions } from "../actions/TwilioActions";
import { WhatsAppChatActions } from "../actions/WhatsAppChatActions";

export interface WhatsAppPatientInfo {
    doctorId: number
    name?: string
    mobileNo: string
}
export interface WhatsAppChatComponentProps {
    patientInfo: WhatsAppPatientInfo
    windowVisible: boolean;
}

interface WhatsAppChatComponentDispatchToProps {
    openChat: (doctorId: string, patientMobileNo: string) => void;
    closeChat: () => void;
    toggleWhatsAppChat: () => void;
}

interface WhatsAppChatComponentStateToProps {
    patientInfo: any,
    windowVisible: boolean,
    windowCollapsed: boolean,
}

export interface WhatsAppChatComponentState {
    // isExpanded: boolean
}


class WhatsAppChatComponent extends React.Component<WhatsAppChatComponentProps & WhatsAppChatComponentStateToProps & WhatsAppChatComponentDispatchToProps, WhatsAppChatComponentState> {

    constructor(props: WhatsAppChatComponentProps & WhatsAppChatComponentStateToProps & WhatsAppChatComponentDispatchToProps) {
        super(props);
        let isExpanded = true;
        // if (window.location.href.includes("ongoing")) {
        //     this.props.toggleWhatsAppChat();
        //     isExpanded = false;
        // }

        this.onCloseHandler = this.onCloseHandler.bind(this);
        // this.state = {
        //     isExpanded,
        // };
    }

    toggleChat = () => {
        // const isExpanded = this.state.isExpanded;
        // this.setState({ isExpanded: !isExpanded });
        this.props.toggleWhatsAppChat();
    };

    onCloseHandler = () => {
        if (
            window.location &&
            window.location.pathname &&
            window.location.pathname.includes("/ongoing")
        ) {
            this.toggleChat();
        } else {
            this.closeChat()
        }
    };

    componentWillUnmount() {
        //this.props.windowCollapsed && this.toggleChat();
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps: WhatsAppChatComponentProps) {
        /*if (nextProps.patientMobileNo !== this.props.patientMobileNo) {
            this.setState({
                isExpanded: true
            });
        }*/
    }

    closeChat = () => {
        if (this.props.closeChat !== undefined)
            this.props.closeChat();
    };


    render() {
        let myInstance = this;
        let cssClass = !myInstance.props.windowCollapsed ? "" : "collapsed";
        const customerInfo = {
            mobileNo: myInstance.props.patientInfo && ("+91-" + myInstance.props.patientInfo.mobileNo),
            name: myInstance.props.patientInfo && myInstance.props.patientInfo.name
        }
        //console.log("Render called")
        return (
            <div className="whatsApp-chat-container-wrapper">
                {/* {
                    myInstance.props.windowVisible && !this.state.isExpanded ?
                        <div className={`collapsed-chat-header`} onClick={this.toggleChat}>
                            <div className="chat-header-title">
                                <img src="/images/icons/curefit-logo.png" height="25px" width="25px" />
                                <span>{customerInfo.name}</span>
                            </div>
                            <img className="upward-arrow" src="/images/back-arrow.png" height="10px" width="7px" />
                        </div> : null
                } */}
                {
                    myInstance.props.windowVisible && myInstance.props.windowCollapsed &&
                    <div className="chat-collapsed">
                        <img src="/images/whatsapp.svg" alt="whatsApp" onClick={this.toggleChat} />
                    </div>
                }
                {
                    myInstance.props.windowVisible && !myInstance.props.windowCollapsed ?
                        <div className={`chat-window-container ${cssClass}`}>
                            <ConverseChat
                                customerInfo={customerInfo}
                                namespace={"shifu"}
                                closable
                                onClose={this.onCloseHandler}
                                config={{ theme: "light" }}
                            />
                        </div> : null
                }
            </div>
        )
    }


}

function mapStateToProps(state: IAppState): WhatsAppChatComponentStateToProps {
    let whatsAppChatContext = state.whatsAppChatContext;
    return {
        patientInfo: whatsAppChatContext.patientInfo,
        windowVisible: whatsAppChatContext.chatWindowVisible,
        windowCollapsed: whatsAppChatContext.chatWindowCollapsed,
    };
}

function mapDispatchToProps(dispatch: any): WhatsAppChatComponentDispatchToProps {
    return {
        openChat: (doctorId: string, patientMobileNo: string) => {
        },
        closeChat: () => {
            dispatch(WhatsAppChatActions.closeWhatsAppChat())
        },
        toggleWhatsAppChat: () => { dispatch(WhatsAppChatActions.toggleWhatsAppChat()) }
    }
}

export default connect<WhatsAppChatComponentStateToProps, WhatsAppChatComponentDispatchToProps, WhatsAppChatComponentProps>(mapStateToProps, mapDispatchToProps)(WhatsAppChatComponent);